import actions from './actions';

const initialState = {
    cajas: [],
    recibos: [],
    egresos: [],
    loadingRecibos: false,
    loadedRecibos: false,
    loadingEgresos: false,
    loadedEgresos: false,
    paginationInfo: {},
    paginationEgresosInfo: {},
    startDate: null,
    endDate: null,
};

export default function cajaReducer(state = initialState, action) {
    switch (action.type) {
        case actions.GET_RECIBOS:
            return {
                ...state,
                loadingRecibos: true,
                loadedRecibos: false,
            }
        case actions.GET_EGRESOS:
            return {
                ...state,
                loadingEgresos: true,
                loadedEgresos: false,
            }
        case actions.GET_CAJAS_SUCCESS:
            return {
                ...state,
                cajas: action.payload,
            }
        case actions.CREATE_TRASLADO_SUCCESS:
            return {
                ...state,
                cajas: [...state.cajas, action.payload]
            }
        case actions.EDIT_CAJA_SUCCESS:
            return {
                ...state,
                cajas: state.cajas.map(caja => caja._id === action.payload._id ? action.payload : caja)
            }
        case actions.DELETE_CAJA_SUCCESS:
            return {
                ...state,
                cajas: state.cajas.filter(caja => caja._id !== action.payload)
            }
        case actions.UPDATE_RECIBOS:
            return {
                ...state,
                recibos: action.payload,
                loadedRecibos: true,
                loadingRecibos: false,
            }
        case actions.UPDATE_EGRESOS:
            return {
                ...state,
                egresos: action.payload,
                loadedEgresos: true,
                loadingEgresos: false,
            }
        case actions.SET_PAGINATION_INFO:
            return {
                ...state,
                paginationInfo: action.payload,
            };
        case actions.SET_PAGINATION_EGRESOS_INFO:
            return {
                ...state,
                paginationEgresosInfo: action.payload,
            };
        case actions.SET_RANGO:
            return {
                ...state,
                startDate: action.startDate,
                endDate: action.endDate
            };
        default:
            return state;
    }

}
